//Verifica si un atributo es obligatorio o no y con base en eso valida si el valor es nulo o indefinido
export function attributeIsValid(key ,value, config){
    let valid = true;
    if (config[key].mandatory === true) {
      if (value === null || value === undefined || value === "") {
        valid = false;
      }
    return valid;
}}